/**
 * Today's calendar date as `YYYY-MM-DD`, read from the device's local clock.
 *
 * `toISOString()` reads the UTC date instead, which in Colombia (UTC-5) is
 * already tomorrow after 19:00: an evening purchase would be dated the next
 * day and never match the bank's row for it.
 */
export function todayLocalISO(date = new Date()) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
